(function() {
  'use strict';

  angular
    .module('admin.publishers.detail', ['admin.publishers.service'])
    .controller('PublisherDetailCtrl', PublisherDetailCtrl);

  /** @ngInject */
  function PublisherDetailCtrl($stateParams, PublisherAdminService) {
    var vm = this;
    vm.items = [];

    PublisherAdminService.get($stateParams.id).then(function(result){
      vm.items = result.results.ch;
    });

  }

})();
